import {useMutation, useQuery, useQueryClient} from "react-query";
import http from "../../../Services/Network/http";
import DataTable from "react-data-table-component";
import {BsFillTrashFill, BsGrid3X3Gap} from "react-icons/bs";
import {Button} from "reactstrap";
import { useNavigate } from "react-router";
import { DataGrid, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarFilterButton, GridToolbarQuickFilter } from '@mui/x-data-grid';

export const AdminProductList = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();
    const deleteProductMutation = useMutation(productId => http.remove(`/product/DeleteProduct/${productId}`), {
        onSuccess: () => {
            queryClient.invalidateQueries(["fetchProducts"]);
        },
        onError: (error) => {
            console.log(error.response.data);
        },
    });
    
    const { data: products } = useQuery(
        "fetchProducts",
        () => http.get(`/Product/GetProducts?filtered=false`));

    const columns = [
        {
            headerName: 'Tittel',
            field: 'title',
            sortable: true,
            flex: 1
        },
        {
            headerName: 'Kategori',
            field: 'productCategory',
            valueGetter: (params) => params?.title,
            sortable: true,
            flex: 0.8
        },
        {
            headerName: 'Leverandør',
            field: 'supplier',
            valueGetter: (params) => params?.name,
            sortable: true,
            flex: 0.8
        },
        {
            headerName: 'Pris',
            field: 'price',
            sortable: true,
            flex: 0.4
        },
        {
            headerName: 'Aktiv',
            field: 'active',
            valueGetter: (value,row) => row.active ? "Ja" : "Nei",
            sortable: true,
            flex: 0.4
        },
        {
            headerName: 'Vises for',
            field: 'productAccessLinks',
            valueGetter: (value, row) => row.productAccessLinks.map((item) => item.costAccount.costAccountName),
            sortable: true,
            multiLine: true,
            flex: 0.4
        },
        {
            headerName: '',
            align: 'right',
            field: 'Valg',
            
            flex: 0.4,
            renderCell: (params) => (
                <>
                    <BsGrid3X3Gap cursor="Pointer" onClick={(event) => { event.stopPropagation(); navigate(`/admin/product/${params.row.productId}/productVariants`) }} />
                    &nbsp;&nbsp;
                    <BsFillTrashFill cursor="Pointer" onClick={(event) => {
                        event.stopPropagation();
                        if(window.confirm("Er du sikker på at du vil slette dette produktet?")) { deleteProductMutation.mutate(params.row.productId) }
                    }} />
                </>
            )
        }];

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <div style={{ flex: 1 }} />
                <GridToolbarQuickFilter debounceMs={150} />
            </GridToolbarContainer>
        );
    }

    return (
        <div>
            <h2 style={{float:'left'}}>Admin &gt; Produkter</h2>
            <Button color="primary" style={{ float: 'right' }} size="sm" onClick={() => navigate("/Admin/Product")}>Legg til nytt produkt</Button>
            <div className="clearfix"></div>
            <DataGrid
                pageSizeOptions={[10, 20, 25, 50, 100]}
                density="compact"
                pagination={true}
                columns={columns}
                slots={{ toolbar: CustomToolbar }}
                onRowClick={(data) => navigate(`/admin/product/${data.row.productId}`)}
                initialState={{
                    pagination: { paginationModel: { pageSize: 20 } },
                    columns: {
                        columnVisibilityModel: {
                            productAccessLinks: false,
                        },
                    },
                }}

                getRowId={(row) => row.productId}
                rows={(products || [])}
            />
        </div>
    );
}